import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import UserLogin from '@/components/UserLogin.vue';
import MainPanel from '@/components/MainPanel.vue';
import UnderConstruction from '@/components/UnderConstruction.vue';
import OperationsModule from '@/components/OperationsModule.vue';
import NewOrder from '@/components/NewOrder.vue';
import NewOrderAssistance from '@/components/NewOrderAssistance.vue';
import CreateNewOrder from '@/components/CreateNewOrder.vue';
import MainMap from '@/components/MainMap.vue';
import TrackMap from '@/components/TrackMap.vue';
import NoteCreationMap from '@/components/NoteCreationMap.vue';
import PointTrackMap from '@/components/PointTrackMap.vue';
import PriceService from '@/components/PriceService.vue';
import NewOrderAuxiliar from '@/components/NewOrderAuxiliar.vue'
import NewOrderForklift from '@/components/NewOrderForklift.vue';
import NewOrderIndustrial from '@/components/NewOrderIndustrial.vue';
import OperatorInterface from '@/components/OperatorInterface.vue';
import OperatorAttendance from '@/components/OperatorAttendance.vue';
import EditAssignation from '@/components/EditAssignation.vue';
import NewOrderLot from '@/components/NewOrderLot.vue';
import PricesRequests from '@/components/PricesRequests.vue';
import EditNote from '@/components/EditNote.vue';
import ResponsiveMap from '@/components/ResponsiveMap.vue';
import StatusUnits from '@/components/StatusUnits.vue';
import MaintenanceModule from '@/components/MaintenanceModule.vue';
import MaintenanceConfigurationModule from '@/components/MaintenanceConfigurationModule.vue';
import MalfunctionReportsModule from '@/components/MalfunctionReportsModule.vue';
import NewUnitMalfunctionReport from '@/components/NewUnitMalfunctionReport.vue';
import ReviewUnitMalfunctionReports from '@/components/ReviewUnitMalfunctionReports.vue';
import UnitMaintenance from '@/components/UnitMaintenance.vue';
import NewMaintenanceOrder from '@/components/NewMaintenanceOrder.vue';
import EditMaintenanceOrder from '@/components/EditMaintenanceOrder.vue';
import IncidentsManagement from '@/components/IncidentsManagement.vue';
import NewIncident from '@/components/NewIncident.vue';
import EditIncident from '@/components/EditIncident.vue';
import MaintenanceOrderFilters from '@/components/MaintenanceOrderFilters.vue';
import UnitIncidentsFilters from '@/components/UnitIncidentsFilters.vue';
import UnitManagement from '@/components/UnitManagement.vue';
import UnitPeriodicMaintenance from '@/components/UnitPeriodicMaintenance.vue';
import UnitLogbook from '@/components/UnitLogbook.vue';
import AddNewUnit from '@/components/AddNewUnit';
import UploadFile from '@/components/upload-file';
import RetrieveFile from '@/components/retrieve-file'
import RHModule from '@/components/RHModule';
import MobileModule from '@/components/MobileModule.vue';
import MobileInstallsAdmin from '@/components/MobileInstallsAdmin.vue';
import MobilePushAdmin from '@/components/MobilePushAdmin.vue';
import MobileSurveyAdmin from '@/components/MobileSurveyAdmin.vue';
import RHPersonal from '@/components/RHPersonal.vue';
import RHAttendanceDashboard from '@/components/RHAttendanceDashboard.vue';
import EmployeeIncidentsFilters from '@/components/EmployeeIncidentsFilters.vue';
import EmployeeReceiptsFilters from '@/components/EmployeeReceiptsFilters.vue';
import RHIncidentsDashboard from '@/components/RHIncidentsDashboard.vue';
import RHNominaMenu from '@/components/RHNominaMenu.vue';
import RHNominaImport from '@/components/RHNominaImport.vue';
import RHNominaCalculate from '@/components/RHNominaCalculate.vue';
import MyIncidents from '@/components/MyIncidents.vue';
import AddNewEmployee from '@/components/AddNewEmployee';
import EditProfile from '@/components/EditProfile.vue';
import GlobalFilters from '@/components/GlobalFilters.vue';
import EditUnitProfile from '@/components/EditUnitProfile.vue';
import ReportsCatalogue from '@/components/ReportsCatalogue.vue';
import AssistReportCreation from '@/components/AssistReportCreation.vue';
import NotesReportCreation from '@/components/NotesReportCreation.vue';
import AccountingModule from '@/components/AccountingModule.vue';
import EditClient from '@/components/EditClient.vue';
import GroupedBilling from '@/components/GroupedBilling.vue';
import ForkliftFilters from '@/components/ForkliftFilters.vue';
import ForkliftGroupedBilling from '@/components/ForkliftGroupedBilling.vue';
import IndustrialGroupedBilling from '@/components/IndustrialGroupedBilling.vue';
import InvoiceFilters from '@/components/InvoiceFilters.vue'
import EditInvoice from '@/components/EditInvoice.vue'
import ReportPendingBilling from '@/components/ReportPendingBilling.vue';
import AccountTransactionsReportCreation from '@/components/AccountTransactionsReportCreation.vue';
import ReportAgingInvoice from '@/components/ReportAgingInvoice.vue';
import ReportLotArrivals from '@/components/ReportLotArrivals.vue';
import ReportLotDepartures from '@/components/ReportLotDepartures.vue';
import EditScheduledNote from '@/components/EditScheduledNote.vue';
import ReportOperatorCommission from '@/components/ReportOperatorCommission.vue';
import AssistClientReportCreation from '@/components/AssistClientReportCreation.vue';
import ReportLotCut from '@/components/ReportLotCut.vue';
import ReportDailySales from '@/components/ReportDailySales.vue';
import ReportUnitPerformance from '@/components/ReportUnitPerformane.vue'
import MasterDashboard from '@/components/MasterDashboard.vue';
import Indicadores from '@/components/IndicadoresDashboard.vue';
import OperatorCommissions from '@/components/OperatorCommissions.vue';
import StatisticsReport from '@/components/StatisticsReport.vue';
import LogsVisorMenu from '@/components/LogsVisorMenu.vue';
import UnitsOverviewDashboard from '@/components/UnitsOverviewDashboard.vue';
import SearchOperationsLogs from '@/components/SearchOperationsLogs.vue';
import SearchAccountingLogs from '@/components/SearchAccountingLogs.vue';
import SearchMaintenanceLogs from '@/components/SearchMaintenanceLogs.vue';
import SearchRRHHLogs from '@/components/SearchRRHHLogs.vue';
import AccessControlManager from '@/components/AccessControlManager.vue';
import VehicleAccessControl from '@/components/VehicleAccessControl.vue';
import GateControl from '@/components/GateControl.vue';
import HelpModule from '@/components/HelpModule.vue';
import BugReportUserPanel from '@/components/BugReportUserPanel.vue';
import BugReportAdminPanel from '@/components/BugReportAdminPanel.vue';
import CallCenterModule from '@/components/CallCenterModule.vue';
import ITMonitoringDashboard from '@/components/ITMonitoringDashboard.vue';
import CallCenterServiceCaptureDashboard from '@/components/CallCenterServiceCaptureDashboard.vue';
import Swal from 'sweetalert2';

const routes = [
    {
        path: '/',
        name: 'UserLogin',
        component: UserLogin,
        meta: { requiresAuth: false}
    },
    {
        path: '/main-panel',
        name: 'MainPanel',
        component: MainPanel,
        meta: {requiresAuth: true}
    },
    {
        path: '/logs',
        name: 'LogsVisorMenu',
        component: LogsVisorMenu,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs']}
    },
    {
        path: '/panel-unidades',
        name: 'UnitsOverview',
        component: UnitsOverviewDashboard,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_units_overview']}
    },
    {
        path: '/logs/operaciones',
        name: 'SearchOperationsLogs',
        component: SearchOperationsLogs,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_operations']}
    },
    {
        path: '/logs/contabilidad',
        name: 'SearchAccountingLogs',
        component: SearchAccountingLogs,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_accounting']}
    },
    {
        path: '/logs/mantenimiento',
        name: 'SearchMaintenanceLogs',
        component: SearchMaintenanceLogs,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_maintenance']}
    },
    {
        path: '/logs/rrhh',
        name: 'SearchRRHHLogs',
        component: SearchRRHHLogs,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_rrhh']}
    },
    {
        path: '/logs/access-control',
        name: 'AccessControlManager',
        component: AccessControlManager,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_access_control']}
    },
    {
        path: '/logs/entradas-y-salidas',
        name: 'VehicleAccessControl',
        component: VehicleAccessControl,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_vehicle_access']}
    },
    {
        path: '/logs/pluma',
        name: 'GateControl',
        component: GateControl,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_logs_gate_control']}
    },
    {
        path: '/it-monitor',
        name: 'ITMonitoringDashboard',
        component: ITMonitoringDashboard,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_it_monitoring']}
    },
    {
        path: '/under-construction',
        name: 'UnderConstruction',
        component: UnderConstruction,
        meta: {requiresAuth: true}
    },
    {
        path: '/ayuda',
        name: 'HelpModule',
        component: HelpModule,
        meta: {requiresAuth: true}
    },
    {
        path: '/ayuda/reportes',
        name: 'BugReportUserPanel',
        component: BugReportUserPanel,
        meta: {requiresAuth: true, requiredPerms: ['maintenance.can_report_bug']}
    },
    {
        path: '/ayuda/admin-reportes',
        name: 'BugReportAdminPanel',
        component: BugReportAdminPanel,
        meta: {requiresAuth: true, requiredPerms: ['maintenance.is_bug_report_admin']}
    },
    {
        path: '/call-center',
        name: 'CallCenterModule',
        component: CallCenterModule,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_call_center_module']}
    },
    {
        path: '/call-center/captura-servicios',
        name: 'CallCenterServiceCaptureDashboard',
        component: CallCenterServiceCaptureDashboard,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_call_center_capture_dashboard']}
    },
    {
        path: '/operations-module',
        name: 'OperationsModule',
        component: OperationsModule,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_operations_module']}
    },
    {
        path: '/new-order',
        name: 'NewOrder',
        component: NewOrder,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/create-new-order',
        name: 'CreateNewOrder',
        component: CreateNewOrder,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/new-order-assistance',
        name: 'NewOrderAssistance',
        component: NewOrderAssistance,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/main-map',
        name: 'MainMap',
        component: MainMap,
        meta: {requiresAuth: true, requiredPerms: ['operations.view_main_map']}
    },
    {
        path: '/track-map',
        name: 'TrackMap',
        component: TrackMap,
        meta: {requiresAuth: true}
    },
    {
        path: '/note-creation-map',
        name: 'NoteCreationMap',
        component: NoteCreationMap,
        meta: {requiresAuth: true}
    },
    {
        path: '/point-track-map',
        name: 'PointTrackMap',
        component: PointTrackMap,
        meta: {requiresAuth: true}
    },
    {
        path: '/cotizar',
        name: 'cotizar',
        component: PriceService,
        meta: {requiresAuth: false}
    },
    {
        path: '/new-order-auxiliar',
        name: 'NewOrderAuxiliar',
        component: NewOrderAuxiliar,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/new-order-forklift',
        name: 'NewOrderForklift',
        component: NewOrderForklift,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/new-order-industrial',
        name: 'NewOrderIndustrial',
        component: NewOrderIndustrial,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/operator-interface',
        name: 'OperatorInterface',
        component: OperatorInterface,
        meta: {requiresAuth: true}
    },
    {
        path: '/mi-asistencia',
        name: 'OperatorAttendance',
        component: OperatorAttendance,
        meta: {requiresAuth: true, requiresRemote: true}
    },
    {
        path: '/mis-incidencias',
        name: 'MyIncidents',
        component: MyIncidents,
        meta: {requiresAuth: true}
    },
    {
        path: '/assignation/:assignation_id',
        name: 'EditAssignation',
        props: true,
        component: EditAssignation,
        meta: {requiresAuth: true}
    },
    {
        path: '/new-order-lot',
        name: 'NewOrderLot',
        component: NewOrderLot,
        meta: {requiresAuth: true, requiredPerms: ['operations.create_assistance_note']}
    },
    {
        path: '/prices-requests',
        name: 'PricesRequests',
        component: PricesRequests,
        meta: {requiresAuth: true, requiredPerms: ['operations.view_pricing_quotes']}
    },
    {
        path: '/notes/:noteID',
        name: 'EditNote',
        component: EditNote,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['operations.view_assistance_note'] } // Assuming you want this page to be protected
    },
    {
        path: '/ver-estatus-unidades',
        name: 'StatusUnits',
        component: StatusUnits,
        meta: {requiresAuth: true, requiredPerms: ['operations.view_status_units']}
    },
    {
        path: '/responsive-map',
        name: 'ResponsiveMap',
        component: ResponsiveMap,
        meta: {requiresAuth: true}
    },
    {
        path: '/modulo-mantenimiento',
        name: 'MaintenanceModule',
        component: MaintenanceModule,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_maintenance_module'] } // Assuming you want this page to be protected
    },
    {
        path: '/maintenance/configuration',
        name: 'MaintenanceConfigurationModule',
        component: MaintenanceConfigurationModule,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_maintenance_configuration'] }
    },
    {
        path: '/unit-maintenance',
        name: 'UnitMaintenance',
        component: UnitMaintenance,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_order_table'] }
    },
    {
        path: '/maintenance/malfunction-reports',
        name: 'MalfunctionReportsModule',
        component: MalfunctionReportsModule,
        meta: { requiresAuth: true }
    },
    {
        path: '/maintenance/malfunction-reports/new',
        name: 'NewUnitMalfunctionReport',
        component: NewUnitMalfunctionReport,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.create_incident'] }
    },
    {
        path: '/maintenance/malfunction-reports/review',
        name: 'ReviewUnitMalfunctionReports',
        component: ReviewUnitMalfunctionReports,
        meta: { requiresAuth: true }
    },
    {
        path: '/maestro-mantenimiento',
        name: 'MaintenanceOrderFilters',
        component: MaintenanceOrderFilters,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_order_master'] }
    },
    {
        path: '/maintenance-order-create',
        name: 'NewMaintenanceOrder',
        component: NewMaintenanceOrder,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.create_order'] }
    },
    {
        path: '/maintenance-order/:orderId',
        name: 'EditMaintenanceOrder',
        component: EditMaintenanceOrder,
        props: true,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_order'] }
    },
    {
        path: '/unit-incidents',
        name: 'IncidentsManagement',
        component: IncidentsManagement,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_incident_table'] }
    },
    {
        path: '/maestro-siniestros',
        name: 'UnitIncidentsFilters',
        component: UnitIncidentsFilters,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_incident_master'] }
    },
    {
        path: '/new-incident',
        name: 'NewIncident',
        component: NewIncident,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.create_incident'] }
    },
    {
        path: '/unit-incidents/:incidentId',
        name: 'EditIncident',
        component: EditIncident,
        props: true,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_incident'] }
    },
    {
        path: '/manejo-unidades/',
        name: 'UnitManagement',
        component: UnitManagement,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_unit_table'] }
    },
    {
        path: '/maintenance/periodic',
        name: 'UnitPeriodicMaintenance',
        component: UnitPeriodicMaintenance,
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_order_table'] }
      },
      {
        path: '/maintenance/unit-logbook',
        name: 'UnitLogbook',
        component: UnitLogbook,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_maintenance_module'] }
      },
    {
        path: '/agregar-nueva-unidad',
        name: 'AddNewUnit',
        component: AddNewUnit,
        meta: {requiresAuth: true, requiredPerms: ['maintenance.create_unit']}
    },
    {
        path : '/test-upload',
        name: 'UploadFile',
        component: UploadFile,
        meta: {requiresAuth: true}
    },
    {
        path : '/test-retrieve',
        name: 'RetrieveFile',
        component: RetrieveFile,
        meta: {requiresAuth: true}
    },
    {
        path: '/modulo-movil',
        name: 'MobileModule',
        component: MobileModule,
        meta: { requiresAuth: true, requiredPerms: ['manage_mobile_app'] }
    },
    {
        path: '/modulo-movil/instalaciones',
        name: 'MobileInstallsAdmin',
        component: MobileInstallsAdmin,
        meta: { requiresAuth: true, requiredPerms: ['manage_mobile_app'] }
    },
    {
        path: '/modulo-movil/notificaciones',
        name: 'MobilePushAdmin',
        component: MobilePushAdmin,
        meta: { requiresAuth: true, requiredPerms: ['manage_mobile_app'] }
    },
    {
        path: '/modulo-movil/encuesta',
        name: 'MobileSurveyAdmin',
        component: MobileSurveyAdmin,
        meta: { requiresAuth: true, requiredPerms: ['manage_mobile_app'] }
    },
    {
        path: '/modulo-personal',
        name: 'RHModule',
        component: RHModule,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/personal',
        name: 'RHPersonal',
        component: RHPersonal,
        meta: { requiresAuth: true, requiredAnyPerms: ['ui_access_rrhh_personal_card', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/asistencia',
        name: 'RHAttendanceDashboard',
        component: RHAttendanceDashboard,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_attendance', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/incidencias',
        name: 'EmployeeIncidentsFilters',
        component: EmployeeIncidentsFilters,
        meta: { requiresAuth: true, requiredAnyPerms: ['ui_access_rrhh_incidents_card', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/recibos',
        name: 'EmployeeReceiptsFilters',
        component: EmployeeReceiptsFilters,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_receipts'] }
    },
    {
        path: '/modulo-personal/tablero-incidencias',
        name: 'RHIncidentsDashboard',
        component: RHIncidentsDashboard,
        meta: { requiresAuth: true, requiredAnyPerms: ['ui_access_rrhh_incidents_dashboard', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/nomina',
        name: 'RHNominaMenu',
        component: RHNominaMenu,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_nomina', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/nomina/importar',
        name: 'RHNominaImport',
        component: RHNominaImport,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_nomina', 'ui_access_rrhh_module'] }
    },
    {
        path: '/modulo-personal/nomina/calcular',
        name: 'RHNominaCalculate',
        component: RHNominaCalculate,
        meta: { requiresAuth: true, requiredPerms: ['ui_access_rrhh_nomina', 'ui_access_rrhh_module'] }
    },
    {
        path: '/agregar-nuevo-personal',
        name: 'AddNewEmployee',
        component: AddNewEmployee,
        meta: {requiresAuth: true, requiredPerms: ['rrhh.create_employee']}
    },
    {
        path: '/employee_details/:employee_ident',
        name: 'EditProfile',
        component: EditProfile,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['rrhh.view_employee_detail'] } // Assuming you want this page to be protected
    },
    {
        path: '/filtros-globales',
        name: 'GlobalFilters',
        component: GlobalFilters,
        meta: {requiresAuth: true, requiredPerms: ['operations.search_assistance_notes']}
    },
    {
        path: '/unit_details/:unit_id',
        name: 'EditUnitProfile',
        component: EditUnitProfile,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['maintenance.view_unit'] } // Assuming you want this page to be protected
    },
    {
        path: '/catalogo-reportes',
        name: 'CatalogoReportes',
        component: ReportsCatalogue,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-papeleta',
        name: 'Papeleta',
        component: AssistReportCreation,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-ordenes-trabajo',
        name: 'ReporteOrdenesTrabajo',
        component: NotesReportCreation,
        meta: {requiresAuth: true}
    },
    {
        path: '/accounting-module',
        name: 'AccountingModule',
        component: AccountingModule,
        meta: { requiresAuth: true, requiredPerms: ['accounting.view_clients_table'] }
    },
    {
        path: '/clients/:client_id',
        name: 'EditClient',
        component: EditClient,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['accounting.view_client_detail'] } // Assuming you want this page to be protected
    },
    {
        path: '/facturar-agrupadas',
        name: 'FacturarAgrupadas',
        component: GroupedBilling,
        meta: { requiresAuth: true, requiredPerms: ['accounting.view_grouped_billing'] }
    },  
    {
        path: '/filtros-montacargas',
        name: 'FiltrosMontacargas',
        component: ForkliftFilters,
        meta: {requiresAuth: true}
    },
    {
        path: '/facturar-agrupadas-montacargas',
        name: 'FacturarAgrupadasMontacargas',
        component: ForkliftGroupedBilling,
        meta: {requiresAuth: true}
    },
    {
        path: '/facturar-agrupadas-industrial',
        name: 'FacturarAgrupadasIndustrial',
        component: IndustrialGroupedBilling,
        meta: {requiresAuth: true}
    },
    {
        path: '/maestro-facturas',
        name: 'InvoiceFilters',
        component: InvoiceFilters,
        meta: { requiresAuth: true, requiredPerms: ['accounting.view_invoice_master'] }
    }, 
    {
        path: '/invoices/:invoiceID/:noteID/:noteNumber/:invoiceIdent',
        name: 'EditInvoice',
        component: EditInvoice,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['accounting.view_invoice_detail'] } // Assuming you want this page to be protected
    },
    {
        path: '/reporte-pendientes-facturar',
        name: 'ReportePendientesFacturar',
        component: ReportPendingBilling,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-movimientos-cartera',
        name: 'ReporteMovimientosCartera',
        component: AccountTransactionsReportCreation,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-antiguedad-saldos',
        name: 'ReporteAntiguedadSaldos',
        component: ReportAgingInvoice,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-entradas-lote',
        name: 'ReporteEntradasLote',
        component: ReportLotArrivals,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-salidas-lote',
        name: 'ReporteSalidasLote',
        component: ReportLotDepartures,
        meta: {requiresAuth: true}
    },
    {
        path: '/scheduled/:scheduledID',
        name: 'EditScheduledNote',
        component: EditScheduledNote,
        props: true, // This allows the component to receive the noteID as a prop
        meta: { requiresAuth: true, requiredPerms: ['operations.view_scheduled_note'] } // Assuming you want this page to be protected
    },
    {
        path: '/reporte-comsiones-operador',
        name: 'ReporteComsionesOperador',
        component: ReportOperatorCommission,
        meta: {requiresAuth: true, requiredPerms: ['rrhh.report_operator_commission']}
    },
    {
        path: '/reporte-papeleta-cliente',
        name: 'PapeletaCliente',
        component: AssistClientReportCreation,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-corte-lote',
        name: 'ReporteCorteLote',
        component: ReportLotCut,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-venta-diaria',
        name: 'ReporteVentaDiaria',
        component: ReportDailySales,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-estadistico-unidades',
        name: 'ReporteEstadisticoUnidades',
        component: ReportUnitPerformance,
        meta: {requiresAuth: true}
    },
    {
        path: '/master-dashboard',
        name: 'MasterDashboard',
        component: MasterDashboard,
        meta: {requiresAuth: true}
    },
    {
        path: '/indicadores',
        name: 'Indicadores',
        component: Indicadores,
        meta: {requiresAuth: true, requiredPerms: ['ui_access_indicadores']}
    },
    {
        path: '/operator-commissions',
        name: 'OperatorCommissions',
        component: OperatorCommissions,
        meta: {requiresAuth: true}
    },
    {
        path: '/reporte-estadistico-clientes',
        name: 'Estadistico',
        component: StatisticsReport,
        meta: {requiresAuth: true}
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

async function getCachedPermissions() {
    try {
        return JSON.parse(localStorage.getItem('userPermissions')) || [];
    } catch (error) {
        return [];
    }
}

async function refreshPermissions() {
    const token = localStorage.getItem('authToken');
    if (!token) {
        return [];
    }
    const apiDirectory = process.env.API_DIRECTORY;
    try {
        const response = await axios.get(`${apiDirectory}/current-user/`, {
            headers: { Authorization: `Token ${token}` },
        });
        const permissions = Array.isArray(response.data?.permissions) ? response.data.permissions : [];
        localStorage.setItem('userPermissions', JSON.stringify(permissions));
        return permissions;
    } catch (error) {
        return [];
    }
}

// Not cached: HR can flip is_remote at any time and a stale "yes" would let a
// device user reach the self-report screen.
async function isRemoteEmployee() {
    const token = localStorage.getItem('authToken');
    if (!token) {
        return false;
    }
    const apiDirectory = process.env.API_DIRECTORY;
    try {
        const response = await axios.get(`${apiDirectory}/current-user/`, {
            headers: { Authorization: `Token ${token}` },
        });
        return Boolean(response.data?.is_remote);
    } catch (error) {
        return false;
    }
}

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresRemote = to.matched.some(record => record.meta.requiresRemote);
    const requiredPerms = to.matched.flatMap(record => record.meta.requiredPerms || []);
    const requiredAnyPerms = to.matched.flatMap(record => record.meta.requiredAnyPerms || []);
    const isAuthenticated = localStorage.getItem('authToken');
    const hasPermission = (permissions, perm) => {
        if (permissions.includes(perm)) return true;
        return permissions.includes(`access_control.${perm}`);
    };
    const hasAllPerms = (permissions) => requiredPerms.every((perm) => hasPermission(permissions, perm));
    const hasAnyPerm = (permissions) => {
        if (!requiredAnyPerms.length) return true;
        return requiredAnyPerms.some((perm) => hasPermission(permissions, perm));
    };
    const hasRouteAccess = (permissions) => hasAllPerms(permissions) && hasAnyPerm(permissions);

    if (requiresAuth && !isAuthenticated) {
        next({ name: 'UserLogin' });
    } else if (requiresRemote && !(await isRemoteEmployee())) {
        Swal.fire({
            title: 'Solo personal remoto',
            text: 'Tu asistencia se registra en el checador.',
            icon: 'warning',
            confirmButtonText: 'Ok',
        });
        // Someone entering by URL has no previous screen to stay on.
        next(from.name ? false : { name: 'OperatorInterface' });
    } else if (requiredPerms.length || requiredAnyPerms.length) {
        let permissions = await getCachedPermissions();
        if (!permissions.length) {
            permissions = await refreshPermissions();
        }
        let hasAccess = hasRouteAccess(permissions);
        if (!hasAccess) {
            permissions = await refreshPermissions();
            hasAccess = hasRouteAccess(permissions);
        }
        if (!hasAccess) {
            Swal.fire({
                title: 'Sin permisos',
                text: 'No tienes permisos para acceder a esta pantalla.',
                icon: 'warning',
                confirmButtonText: 'Ok',
            });
            next(false);
        } else {
            next();
        }
    } else if (!requiresAuth && isAuthenticated && to.name === 'UserLogin' && !to.query.next) {
        // A ?next= param means a session-based flow (MCP assistant OAuth
        // consent) sent the browser here: show the login form even if the
        // SPA has a token, because the Django session cookie may be missing.
        next({ name: 'MainPanel' });
    } else {
        next();
    }
});

export default router